import React from "react";

const Icon: React.FC = (props) => {
  return (
    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg" style={{marginRight: 5}}>
        <path d="M7 14.5312C10.7461 14.5312 13.7812 11.4961 13.7812 7.75C13.7812 4.00391 10.7461 0.96875 7 0.96875C3.25391 0.96875 0.21875 4.00391 0.21875 7.75C0.21875 11.4961 3.25391 14.5312 7 14.5312ZM10.1719 6.54688C10.3359 6.54688 10.5 6.71094 10.5 6.875V8.625C10.5 8.81641 10.3359 8.95312 10.1719 8.95312H7V10.8945C7 11.1953 6.64453 11.332 6.42578 11.1406L3.30859 7.99609C3.17188 7.85938 3.17188 7.66797 3.30859 7.53125L6.42578 4.38672C6.64453 4.16797 7 4.33203 7 4.63281V6.54688H10.1719Z" fill="#E92B4D"/>
    </svg>
  );
};

export default Icon;
